import { useState, useEffect, useCallback } from 'react'
import { clientBenefitsService } from '../services/clientBenefitsService'
import { vouchersService } from '../services/vouchersService'
import type { ClientBenefit, ClientBenefitHistoryItem, BenefitVoucher } from '../types'

export function useClientBenefits(clientId: number) {
  const [activeBenefits, setActiveBenefits] = useState<ClientBenefit[]>([])
  const [allBenefits, setAllBenefits] = useState<ClientBenefitHistoryItem[]>([])
  const [vouchers, setVouchers] = useState<BenefitVoucher[]>([])
  const [category, setCategory] = useState<string>('')
  const [usedCount, setUsedCount] = useState(0)
  const [expiredCount, setExpiredCount] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const [activeResponse, allResponse, vouchersResponse] = await Promise.all([
        clientBenefitsService.getActive(clientId),
        clientBenefitsService.getAll(clientId),
        vouchersService.getByClient(clientId),
      ])
      setActiveBenefits(activeResponse.active_benefits)
      setCategory(activeResponse.category)
      setUsedCount(activeResponse.used_benefits_count)
      setExpiredCount(activeResponse.expired_benefits_count)
      setAllBenefits(allResponse)
      setVouchers(vouchersResponse)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar beneficios del cliente')
    } finally {
      setIsLoading(false)
    }
  }, [clientId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    activeBenefits,
    allBenefits,
    vouchers,
    category,
    usedCount,
    expiredCount,
    isLoading,
    error,
    refetch: fetchData,
  }
}
